import React from 'react';
import './Infographic.scss';
import InfographicCarousel from './InfographicCarousel';

function Infographic({ touch }) {
  return (
    <figure className="carousel">
      <div className="carousel__contents">
        <h3>
          Different types of
          <br />
          homebuyers
        </h3>

        <InfographicCarousel touch={touch} />
      </div>
      <figcaption className="captions ">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Infographic;
